import {Component, EventEmitter, Input, OnInit, Output} from '@angular/core';
import {NgxPopupComponent} from '@components/shared/ngx-popups/ngx-popups/components/popup.component';
import {AlertService} from '@services/alert.service';
import {SpreadingTemplateService} from "@services/spreading-template.service";

@Component({
    selector: 'app-edit-attestation-text-modal',
    templateUrl: './edit-attestation-text-modal.component.html',
    styleUrls: ['./edit-attestation-text-modal.component.scss'],
    standalone: false
})
export class EditAttestationTextModalComponent implements OnInit {
  @Input() popup: NgxPopupComponent; // MANDATORY
  @Input() initialAttestationText: string;
  @Input() templateUuid = null;

  @Output() updatedAttestationText = new EventEmitter<string>();

  attestationText: string;

  constructor(
    private spreadingTemplateService: SpreadingTemplateService,
    private alertService: AlertService,
  ) {

  }

  ngOnInit() {
    this.attestationText = this.initialAttestationText;
  }

  handleSave() {
    this.spreadingTemplateService.updateAttestationText(this.templateUuid, {attestationText: this.attestationText}).subscribe(result => {
      this.alertService.success("Successfully updated Attestation Text.");
      this.updatedAttestationText.emit(this.attestationText)
      this.popup.close();
    }, error => {
      console.error(error);
      this.alertService.error("Failed to update Attestation Text!");
    })
  }

  closeModal() {
    this.popup.close();
  }

}
